import React from 'react';
import { PAGERDUTY_INTEGRATION_KEY, PAGERDUTY_SERVICE_ID } from '../constants.esm.js';
import { useEntity } from '@backstage/plugin-catalog-react';
import { getPagerDutyEntity } from '../pagerDutyEntity.esm.js';
import { PagerDutySmallCard } from '../PagerDutySmallCard/index.esm.js';

const isPluginApplicableToEntity = (entity) => {
  var _a, _b;
  return Boolean(
    ((_a = entity.metadata.annotations) == null ? void 0 : _a[PAGERDUTY_INTEGRATION_KEY]) || ((_b = entity.metadata.annotations) == null ? void 0 : _b[PAGERDUTY_SERVICE_ID])
  );
};
const EntityPagerDutySmallCard = (props) => {
  const { readOnly, disableInsights, disableOnCall } = props;
  const { entity } = useEntity();
  const pagerDutyEntity = getPagerDutyEntity(entity);
  return /* @__PURE__ */ React.createElement(
    PagerDutySmallCard,
    {
      ...pagerDutyEntity,
      readOnly,
      disableInsights,
      disableOnCall
    }
  );
};

export { EntityPagerDutySmallCard, isPluginApplicableToEntity };
//# sourceMappingURL=index.esm.js.map
